import React from 'react';
import CircularProgress from '@material-ui/core/CircularProgress';

const Preloader = () => {
  return (
    <div style={{ position: 'absolute', left: '50%', top: '50%', transform: 'translateX(-50%) translateY(-50%)', textAlign: 'center' }}>
      <CircularProgress />
      <div style={{ marginTop: 10, fontFamily: 'National-Light, "Calibri Light", Calibri, "Helvetica Neue"' }}>Loading...</div>
    </div>
  );
};

export default Preloader;


// WEBPACK FOOTER //
// ./src/components/Preloader.js